export default __webpack_public_path__ + "static/3-5b71187f071dc6dd302aea77f16b7749.png";